import React, {useState} from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { ContainerCoverVideo, Container, TitleSub, HeaderSdg, ContainerChart } from '../../components/AppComponents';
import { figure51 } from '../../graphs/fr/figure51';
import Modal from '../../components/Modal';

const Sdg10 = () => {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(false);

    const handleClickOpen = (value) => {
        setOpen(true);
        setText(value);
    };

    const handleClose = (value) => {
        setOpen(false);
        setText(value);
    };
    return (
      
        <React.Fragment>
            <Modal
                text={text}
                open={open}
                onClose={handleClose}
            />
            <ContainerCoverVideo 
                id="10" 
                poster={require('../../images/poster-sdg-10.png').default}
                video={require('../../images/video-sdg-10.mp4').default}
                sdgImage={require('../../images/EN_10.svg').default}
                sdg="OBJECTIF DE DÉVELOPPEMENT DURABLE 10"
                title="Inégalités réduites"
                subtitle="Réduire les inégalités dans les pays et d’un pays à l’autre."
                indicators={['10.a.1']}  
                indicatorsTitle="INDICATEUR"
            />

<Container>
                <TitleSub title="Vue d’ensemble" />
<p>La pandémie de covid-19 a renversé la tendance récente, qui s’étend sur plusieurs décennies, à la baisse des inégalités de revenus à l’échelle mondiale. Le relèvement plus ou moins rapide d’une région à l’autre menace d’aggraver ces inégalités.</p>
<p>Les pays ayant des revenus relativement faibles risquent de prendre encore plus de retard. La pandémie a également intensifié les discriminations structurelles et systémiques. Les marchés émergents et les économies en développement connaissent un relèvement lent, qui aggrave les disparités de revenus entre les pays. La réalisation de l’ODD 10 nécessite donc des efforts concertés et accélérés pour lutter contre les causes profondes des inégalités entre les pays et au sein des pays.</p>
<div id="section10.a.1">
                  <HeaderSdg 
                      title="INDICATEUR 10.A.1 DES ODD"
                        subtitle={["Proportion de lignes tarifaires concernées par les importations en provenance des pays les moins avancés (PMA) et des pays en développement bénéficiant d’une franchise de droits", <sup>6</sup>]}
                      target={{
                          sdg: "10",
                          title: 'Cible 10.a',
                          text: 'Mettre en œuvre le principe d’un traitement spécial et différencié pour les pays en développement, en particulier les pays les moins avancés, conformément aux accords de l’Organisation mondiale du commerce.'
                      }}
                  />
                </div>
<p><b>L’accès en exemption de droits des pays en développement et des PMA aux marchés internationaux des exportations s’est amélioré ces dernières années, en particulier pour les produits agricoles. Toutefois, la faible croissance générale des exportations en provenance de PMA demeure inquiétante.</b></p>
<p>La cible 10.a du Programme 2030 cherche à améliorer les conditions d’accès au marché des exportations en provenance des pays en développement et des PMA, en leur donnant un traitement spécial et différencié, conformément aux accords de l’OMC. L’indicateur 10.a.1 des ODD montre comment ce traitement spécial et différencié est appliqué aux droits à l’importation, et est calculé comme la proportion de lignes tarifaires concernées par les importations en provenance des PMA et des pays en développement bénéficiant d’une franchise de droits. L’indicateur montre dans quelle mesure les pays en développement et les PMA bénéficient d’un accès libre aux marchés des pays développés.</p>
<p>Comme le montre la figure 51, les pays en développement et les PMA jouissent d’un accès total ou presque total à la plupart des marchés internationaux en franchise de droits et de quotas. Entre 2015 et 2021, la part de produits exportés par les PMA pouvant intégrer les marchés internationaux en franchise de droits a augmenté, passant de 63,8 pour cent à 64,1 pour cent. Toutefois, cette augmentation était plus importante en particulier pour les produits agricoles, avec un taux passant de 69 pour cent en 2015 à 73,6 pour cent en 2021.</p>
<p>Parallèlement à cela, cette part a augmenté pour les pays en développement (passant de 49,4 pour cent à 54,6 pour cent) et les PEID (passant de 62,3 pour cent à 72,5 pour cent). Au cours de la même période, la part de produits agricoles exportés par les pays en développement et par les PEID qui pouvaient intégrer les marchés internationaux en franchise de droits est passée, respectivement, de 50,8 pour cent à 55,4 pour cent et de 62,5 pour cent à 73,2 pour cent.</p>
<p>Ainsi, comme le montre également la figure 51, le traitement préférentiel accordé aux exportations agricoles en provenant des pays en développement, des PMA, des pays en développement sans littoral et des PEID était légèrement moins favorable que celui accordé aux autres types d’exportations. Néanmoins, et malgré l’amélioration enregistrée depuis 2015, le principe de traitement spécial et différencié, l’un des principaux moteurs pour réduire les inégalités mondiales, est loin d’être pleinement mis en œuvre. Il convient de noter par ailleurs que les progrès en matière d’expansion des exportations en provenance des PMA sont lents. Bien que les exportations en provenance des PMA se soient multipliées depuis 2000, leur part dans le commerce international global stagne autour de 1 pour cent depuis dix ans. En parallèle, la part des PMA au sein de la population mondiale est passée de 10,7 pour cent en 2000 à plus de 13,6 pour cent en 2020.</p>
</Container>
<ContainerChart 
                title="Figure 51. Part des exportations en provenance de régions enregistrant différents niveaux de développement bénéficiant d’une franchise de droits sur les marchés internationaux (2015 et 2021)"
                legend={[
                    {title: '2015', color: '#fde9fb'},
                    {title: '2021', color: '#ff3399'},
                ]}
                note={<span><b>Source:</b> Nations Unies. 2023. Indicateurs de suivi des ODD. Dans: <i>Division de statistique des Nations Unies.</i> New York. [Consulté le 8 juin 2023]. <a href="https://unstats.un.org/sdgs/dataportal/database">https://unstats.un.org/sdgs/dataportal/database</a></span>}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={figure51}
                />
                
            </ContainerChart>

	    <Container>
	       <div className="footnotes">
		  <p id="footnote1"><sup>6 </sup>
	     L’indicateur 10.a.1 des ODD relève de la responsabilité du Centre du commerce international, de la Conférence des Nations Unies sur le commerce et le développement et de l’Organisation mondiale du commerce.
	     <br/><br/>
     	     <br/><br/>
		  </p>
	       </div>
	    </Container>
	</React.Fragment>
    ) 
}


export default Sdg10;
